import { CompletePageConditionalRuleModel } from '@/domain/model/forms'

type SeparatedRules = {
  update: CompletePageConditionalRuleModel[]
  new: Omit<CompletePageConditionalRuleModel, 'is_new'>[]
}

export const getSeparateCompleteConditionalRule = (
  rules: CompletePageConditionalRuleModel[]
) => {
  const result: SeparatedRules = {
    update: [],
    new: [],
  }

  rules.forEach((rule) => {
    if (rule.is_new) {
      const newRule = { ...rule, is_new: undefined }
      result.new.push(newRule)
    }

    if (!rule.is_new && rule.is_updated) {
      result.update.push(rule)
    }
  })

  return result
}
